import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { initialState, SLICE_NAMESPACE } from './shortcuts.constants';
import { reducers } from './shortcuts.reducers';

const shortcutsSlice = createSlice({
  name: SLICE_NAMESPACE,
  initialState,
  reducers,
  extraReducers,
});

export const {
  updateShortcutsListQuery,
  updateShortcutsListPage,
  updateShortcutsFiltersPriceGroupIds,
  updateShortcutsFiltersPriceListIds,
  resetShortcutForm,
  resetDeleteConfirmation,
  resetShortcutListPagination,
} = shortcutsSlice.actions;

export default shortcutsSlice.reducer;
